import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { addProduct, updateProduct } from "../../../services/userMasterUser";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { getLeadType } from "../../../services/leads";

export default function ProductCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [input, setInput] = useState({
    name: state?.name || "",
    description: state?.description || "",
    category: state?.category || "OTHER",
    status: state?.status || "ACTIVE",
    amount: state?.amount || 0
  });
  const [errors, setErrors] = useState({
    name: "",
    description: "",
    category: "",
    status: "",
  });

  const [categoryData, setCategoryData] = useState([])

  const fetchData = () => {

    getLeadType()
      .then((response) => {
        if (!response.data.error) {
          const leadType = response.data.map((item) => ({
            label: item,
            value: item,
          }));

          const OtherType = {
            label: "Other",
            value: "Other",
          }
          const dataList = [...leadType, OtherType]
          // add one more data other in this and open filed for input
          setCategoryData(dataList);
        }
      })
      .catch(() => errorMessage());
  }

  useEffect(() => {
    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
      }));
    }
    fetchData()
  }, [state]);


  // const categoryData = [ 
  //   { label: "LOAN", value: "LOAN" },
  //   { label: "REPORT", value: "REPORT" },
  //   { label: "OTHER", value: "OTHER" },
  // ]

  const [statusData, setStatusData] = useState([
    { label: "ACTIVE", value: "ACTIVE" },
    { label: "INACTIVE", value: "INACTIVE" }
  ]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;

    if (!(input.name)) {
      newErrors.name = "Please Enter Name";
      isValid = false;
    } else {
      newErrors.name = "";
    }



    if (input.description === "") {
      newErrors.description = "Please Enter Description";
      isValid = false;
    } else {
      newErrors.description = "";
    }

    if (input.category === "") {
      newErrors.category = "Please Enter Category";
      isValid = false;
    } else {
      newErrors.category = "";
    }

    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          id: state?.id,
          name: input.name,
          description: input.description,
          category: input.category,
          status: input.status,
          amount: input.amount
        };
        updateProduct(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/product/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          name: input.name,
          description: input.description,
          category: input.category,
          amount: input.amount
        };
        addProduct(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/product/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/product/list")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> Product {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Name
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="name"
                        name="Name"
                        value={input.name}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            name: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.name}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Description
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="description"
                        name="Description"
                        value={input.description}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            description: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.description}</div>
                    </div>
                  </div>

                   <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="status" className="form-label">
                        Department
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={categoryData}
                        value={input.category}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            category: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.category}</div>
                    </div>
                    {state?.id &&<div className="col-md-6">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={statusData}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>}
                  </div>
                  {input.category !== "LOAN" && <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="status" className="form-label">
                        Amount (Fee or Changes) (In Rupees)
                      </label>
                      <InputText
                        type="number"
                        style={{ width: "100%" }}
                        id="amount"
                        name="Amount"
                        value={input.amount}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            amount: e.target.value,
                          });
                        }}
                        required
                      />
                    </div>
                  </div>}
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
